/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../xp/oauth/datatypes/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "common": {
                "nested": {
                  "ReleaseStatus": {
                    "values": {
                      "PUBLIC": 1,
                      "BETA": 2,
                      "UPCOMING": 3,
                      "INTERNAL": 4,
                      "EXCLUDED": 5,
                      "ALPHA": 6,
                      "DEPRECATED": 7,
                      "RETIRED": 8
                    }
                  },
                  "AuthenticationMethod": {
                    "values": {
                      "OAUTH2_ACCESS_TOKEN": 2,
                      "OAUTH2_CLIENT_SECRET": 3,
                      "MULTIPASS": 4
                    }
                  },
                  "AuthenticationMethods": {
                    "fields": {
                      "value": {
                        "type": ".squareup.connect.v2.common.AuthenticationMethod",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "OAuthPermissions": {
                    "fields": {
                      "value": {
                        "type": ".squareup.xp.oauth.datatypes.Scope",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "HTTPMultiPartSettings": {
                    "fields": {
                      "mimeTypes": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "disableProtoValidation": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "Features": {
                    "fields": {
                      "flags": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "ExternalDoc": {
                    "fields": {
                      "description": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "url": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "SparseUpdateRequestLevelSkippedFields": {
                    "fields": {
                      "values": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.common?.nested?.ReleaseStatus && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.common?.nested?.AuthenticationMethod && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.common?.nested?.AuthenticationMethods && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.common?.nested?.OAuthPermissions && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.common?.nested?.HTTPMultiPartSettings && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.common?.nested?.Features && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.common?.nested?.ExternalDoc && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.common?.nested?.SparseUpdateRequestLevelSkippedFields) {
  $root.addJSON(jsonData);
}

/**
 * Release status with PUBLIC as default. These alter what is added to documentation
 * in the doc build pipeline, you can read more in the wiki on docs architecture:
 * https://wiki.sqcorp.co/display/REG/Developer+Documentation, and find where
 * each of these are deployed to (see the connectv2-docs project).
 *
 * A standard release process for a big feature release
 * (e.g. exposing a new endpoint.) should be ALPHA -> BETA -> PUBLIC. By ending life
 * of a feature, the status goes from BETA or PUBLIC to DEPRECATED.
 * See go/plathome for more details.
 *
 * SOURCE ReleaseStatus @ squareup/connect/v2/common/options.proto at 33:1
 */
export const ReleaseStatus = $root.lookupEnum('squareup.connect.v2.common.ReleaseStatus').values;
/**
 * AuthenticationMethod defines whether an endpoint has authentication,
 * and which authentication method it uses.
 * It affects the Open API spec is generated for the annotated endpoint,
 * and controls which types of authN are supported by Multipass.
 * If no methods are specified, all types of sessions are allowed.
 *
 * SOURCE AuthenticationMethod @ squareup/connect/v2/common/options.proto at 72:1
 */
export const AuthenticationMethod = $root.lookupEnum('squareup.connect.v2.common.AuthenticationMethod').values;
/**
 * SOURCE AuthenticationMethods @ squareup/connect/v2/common/options.proto at 116:1
 */
export const AuthenticationMethods = $root.lookupType('squareup.connect.v2.common.AuthenticationMethods');
fixType(AuthenticationMethods);
Builder.createAndAttachToType(AuthenticationMethods);
/**
 * SOURCE OAuthPermissions @ squareup/connect/v2/common/options.proto at 120:1
 */
export const OAuthPermissions = $root.lookupType('squareup.connect.v2.common.OAuthPermissions');
fixType(OAuthPermissions);
Builder.createAndAttachToType(OAuthPermissions);
/**
 * SOURCE HTTPMultiPartSettings @ squareup/connect/v2/common/options.proto at 124:1
 */
export const HTTPMultiPartSettings = $root.lookupType('squareup.connect.v2.common.HTTPMultiPartSettings');
fixType(HTTPMultiPartSettings);
Builder.createAndAttachToType(HTTPMultiPartSettings);
/**
 * Defines a set of features that are related to a field.
 *
 * SOURCE Features @ squareup/connect/v2/common/options.proto at 137:1
 */
export const Features = $root.lookupType('squareup.connect.v2.common.Features');
fixType(Features);
Builder.createAndAttachToType(Features);
/**
 * SOURCE ExternalDoc @ squareup/connect/v2/common/options.proto at 143:1
 */
export const ExternalDoc = $root.lookupType('squareup.connect.v2.common.ExternalDoc');
fixType(ExternalDoc);
Builder.createAndAttachToType(ExternalDoc);
/**
 * SOURCE SparseUpdateRequestLevelSkippedFields @ squareup/connect/v2/common/options.proto at 148:1
 */
export const SparseUpdateRequestLevelSkippedFields = $root.lookupType('squareup.connect.v2.common.SparseUpdateRequestLevelSkippedFields');
fixType(SparseUpdateRequestLevelSkippedFields);
Builder.createAndAttachToType(SparseUpdateRequestLevelSkippedFields);